
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
    name: "OpenServiceApply",
    components: {
        pdf
    },
    data() {
        return {
            pdfSrc: '',
            numPages: 0,
            progress: 0,
            progressShow: true,
            openServiceApplyForm: {
                cName: '',
                isAgree: false,
                isSend: false,
                isReceive: false
            },
            receiveDisable: false,
            sendDisable: false,
            platformAuditResult: '',
            isReceivePassed: false,
            isSendPassed: false,
        }
    },
    mounted: function () {
    },
    created() {
        this.onInit();
    },
    computed: {
        rules() {
            const checkAgree = (rule, value, callback) => {
                setTimeout(() => {
                    console.log('openServiceApplyForm'+ this.openServiceApplyForm.isAgree)
                    if (this.openServiceApplyForm.isAgree) {
                        callback()
                    } else {
                        callback(new Error(this.$t('openServiceApply.message.isAgree')))
                    }
                }, 100)
            };
            return {
                openServiceList: [
                    {type: 'array', required: true, message: this.$t('openServiceApply.message.openServiceList'), trigger: 'change'}
                ],
                isAgree: [
                    {validator: checkAgree, trigger: ['blur', 'change']}
                ]
            }
        },
    },
    methods: {
        submitForm(formName) {
            const param = Object.assign({}, param, this.openServiceApplyForm);
                if (param.isSend && !this.sendDisable) {
                    // param.applyService = "1";
                    param.applyServiceBill = "1";
                }
                if (param.isReceive && !this.receiveDisable) {
                    // param.applyServiceBill = "1";
                    param.applyService = "1";
                }
                delete param.isAgree;
                delete param.cName;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(param);
                    if(!param.applyServiceBill && !param.applyService){
                        this.$message({
                            message: this.$t('openServiceApply.message.openServiceList'),
                            type: 'warning',
                            center: true
                        });
                        return ;
                    }
                    if (this.platformAuditResult !== 1) {
                        this.$message({
                            message: this.$t('openServiceApply.message.platformAuditResultIsNot'),
                            type: 'warning',
                            center: true
                        });
                        return ;
                    } 
                    this.$axios.post('/api/companyapplyservice/insertservice', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.onInit();
                            // this.$router.push('/home');
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        // 重置表单
        resetForm(formName) {
            console.log(this.$refs[formName].model.openServiceList);
            // 重置服务申请
            this.$refs[formName].model.openServiceList = [];
            // 重置是否同意协议内容
            this.$refs[formName].model.isAgree = [];
        },
        // 加载PDF
        loadPdfHandler () {
            this.pdfSrc.promise.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
        confirmCancelOpenService() {
            this.$confirm(this.$t('openServiceApply.confirmCancelOpenService'), {
              confirmButtonText: this.$t('openServiceApply.determine'),
              cancelButtonText: this.$t('openServiceApply.cancel'),
              type: 'warning'
            }).then(() => {
                this.$router.push('/home');
            }).catch(() => {
            });
          },
          agreeChange(val){
            console.log('change'+ val);
            this.openServiceApplyForm.isAgree = val;
          },
          onInit() {
             // 获取当前登录人的公司信息和开通服务协议
            this.$axios.get('/api/customerinfo/selectopeninapply').then(response => {
                // 平台审核结果
                this.platformAuditResult = response.data.resultData.platformAuditResult;
                this.openServiceApplyForm = response.data.resultData;
                this.openServiceApplyForm.cName = response.data.resultData.companyName;
                console.log(this.openServiceApplyForm);
                if (this.openServiceApplyForm.isSend === 2) {
                    this.openServiceApplyForm.isSend = true;
                    this.sendDisable = true;
                    // 2021-01-29 补充审核通过的标注
                    this.isSendPassed = true;
                }
                if (this.openServiceApplyForm.isReceive === 2) {
                    this.openServiceApplyForm.isReceive = true;
                    this.receiveDisable = true;
                    // 2021-01-29 补充审核通过的标注
                    this.isReceivePassed = true;
                }
                // 2021-01-29 补充待审核的标注
                if (this.openServiceApplyForm.isSend === 1) {
                    this.sendDisable = true;
                }
                if (this.openServiceApplyForm.isReceive === 1) {
                    this.receiveDisable = true;
                }
                if (response.data.resultData.protocols) {
                    response.data.resultData.protocols.forEach(file => {
                        if (file.lang === 1) {
                            this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
                            // this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
                            this.pdfSrc.onProgress = progress => {
                                let tempProgress = progress.loaded / progress.total * 100;
                                    if(tempProgress > 100){
                                        tempProgress = 100;
                                    }
                                    this.progress = tempProgress;
                                    if (this.progress === 100) {
                                        setTimeout(() => {
                                            this.progressShow = false;
                                            for(const key in require.cache) {
                                                if(require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
                                                    console.log(key);
                                                    delete require.cache[key];
                                                }
                                            }
                                        }, 500);
                                    }
                            };
                            this.loadPdfHandler();
                        }
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
          }

    }
}
